import { all } from 'redux-saga/effects';
import GroupSetsSagas from './groupSets.sagas';
import DeteriorationModelsSagas from './deteriorationModels.sagas';
import InspectionsSagas from './inspections.sagas';
import FailureDefinitionSagas from './failureDefinition.sagas';
import RehabSagas from './rehab.sagas';
import FailureGradeSagas from './failureGrade.sagas';

export default function* rootSaga() {
	yield all([
		...GroupSetsSagas,
		...DeteriorationModelsSagas,
		...InspectionsSagas,
		...FailureDefinitionSagas,
		...RehabSagas,
		...FailureGradeSagas,
	]);
}
